import type { Dispatch, SetStateAction } from "react";
import { Button } from "@/components/ui/button";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from "@/components/ui/tooltip";
import { getColorByValue } from "../../../lib/helpers";
import type { AnalystsEstimatesChartTimeFrame } from "../../../types";

type ChartSettingsPanelProps = {
	switchLabel: string | AnalystsEstimatesChartTimeFrame | undefined;
	hoverLabel?: string;
	handleSwitch: () => void;
	isDisabledButton?: boolean;
	toggles: string[];
	selectedToggles: string[];
	setSelectedToggles: Dispatch<SetStateAction<string[]>>;
};

export const ChartSettingsPanel = ({
	switchLabel,
	hoverLabel,
	handleSwitch,
	isDisabledButton,
	toggles,
	selectedToggles,
	setSelectedToggles,
}: ChartSettingsPanelProps) => {
	const handleValueChange = (value: string[]) => {
		setSelectedToggles(value);
	};

	return (
		<div className="flex items-center w-full py-1">
			<Tooltip>
				<TooltipTrigger asChild>
					<Button
						className="flex p-0 m-0 pr-1 text-base text-wrap text-gold hover:text-gold font-bold cursor-pointer h-auto"
						onClick={handleSwitch}
						disabled={isDisabledButton}
					>
						{switchLabel}
					</Button>
				</TooltipTrigger>
				{hoverLabel && <TooltipContent>{hoverLabel}</TooltipContent>}
			</Tooltip>

			<ToggleGroup
				className="flex"
				type="multiple"
				value={selectedToggles}
				onValueChange={handleValueChange}
			>
				{toggles.map((value: string) => (
					<ToggleGroupItem
						key={value}
						value={value}
						aria-label={`Toggle ${value}`}
						className="flex p-1 h-5 data-[state=on]:border cursor-pointer items-center gap-1"
						style={{ borderColor: getColorByValue(value, toggles) }}
					>
						{value}
					</ToggleGroupItem>
				))}
			</ToggleGroup>
		</div>
	);
};
